import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListView } from '../../list-view/list-view';
import { CategoriesService } from '../../shared/services/categories-service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentUrl } from '../../shared/services/environment-url';

@Component({
  selector: 'app-categoris',
  imports: [ListView],
  templateUrl: './categories.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './categories.css',
})
export class CategoriesType {
  categoriesService?: CategoriesService;

  constructor(
    private http: HttpClient,
    private envUrl: EnvironmentUrl,
  ) {
    this.categoriesService = new CategoriesService(this.http, this.envUrl);
  }
}
